import React, { FC } from 'react';
import { BreakpointsInPx } from '../../../../constants/breakpoints.constants';
import { iconSize } from '../../../../constants/icon.constants';
import { getImageField } from '../../../../utils/getImageFields';
import { getThumbnailProps } from '../../../../utils/youtubeUtils';
import Picture from '../../../@shared/picture';
import VideoPlayer from '../../../@shared/videoPlayer';
import { TEventDetailMediaProps } from '../types/eventDetail.types';
import useMediaQuery from '../../../../lib/custom-hooks/useMediaQuery';

const EventDetailMedia: FC<TEventDetailMediaProps & { isMediaExists: boolean }> = ({
  showVideo,
  desktopImage,
  mobileImage,
  video,
  isMediaExists,
}) => {
  const isDesktop = useMediaQuery(`(min-width: ${BreakpointsInPx['tbl-p']}px)`);
  const videoUrl = video?.value?.href;

  if (!isMediaExists) {
    return null;
  }

  if (showVideo) {
    const { thumbnailImgSrc } = getThumbnailProps(videoUrl || '');
    const desktopImageOrThumbnail = getImageField(desktopImage, thumbnailImgSrc ?? '', showVideo);
    const mobileImageOrThumbnail = getImageField(mobileImage, thumbnailImgSrc ?? '', showVideo);

    return (
      <div className="event-detail__media-wrapper event-detail__media--thumbnail">
        <VideoPlayer
          link={videoUrl}
          autoPlay={true}
          showThumbnail={true}
          desktopPlayIconSize={iconSize.xlg}
          mobilePlayIconSize={iconSize.dsk}
          videoPlayerWrapperClassName="event-detail__media--video"
          editorialImageProps={{
            mobileImage: mobileImageOrThumbnail,
            desktopImage: desktopImageOrThumbnail,
            isEditable: true,
            alt: (isDesktop
              ? desktopImageOrThumbnail?.value?.alt
              : mobileImageOrThumbnail?.value?.alt) as string,
            cssClassImageEl: 'event-detail__media--preview-image',
          }}
          extraClassName={'event-detail__media-wrapper--video'}
        />
      </div>
    );
  }

  return (
    <Picture
      editorialImageProps={{
        desktopImage: desktopImage,
        mobileImage: mobileImage,
        desktopTransformation: 'Size1000',
        mobileTransformation: 'Size1000',
        cssClassPictureEl: 'event-detail__media--image',
      }}
    />
  );
};

export default EventDetailMedia;
